import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const CircledPlayIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 39),
    ...svgProps,
    children: [/*#__PURE__*/jsx("path", {
      d: "m26.87 18.62a1 1 0 0 1 0 1.76l-9.9 5.33a1 1 0 0 1 -1.47-.88v-10.66a1 1 0 0 1 1.47-.88z",
      fill: color ?? "currentColor"
    }), /*#__PURE__*/jsxs("g", {
      fill: "none",
      stroke: color ?? "currentColor",
      strokeWidth: "2",
      children: [/*#__PURE__*/jsx("circle", {
        cx: "19.5",
        cy: "19.5",
        r: "19.5",
        stroke: "none"
      }), /*#__PURE__*/jsx("circle", {
        cx: "19.5",
        cy: "19.5",
        r: "18.5"
      })]
    })]
  });
};

export { CircledPlayIcon };
//# sourceMappingURL=play.circled.js.map
